var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "period-selector" },
    _vm._l(_vm.periodOptions, function (period) {
      return _c(
        "span",
        {
          key: period.value,
          staticClass: "period-option",
          class: { active: _vm.selectedPeriod === period.value },
          on: {
            click: function ($event) {
              return _vm.onPeriodClick(period.value)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t(period.labelKey)) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }